import { api } from '../utils/apiHelpers';
import {
  creditCardDtoToPaymentMethod,
  creditCardDtoToPaymentMethodTransformer,
  invoicesLegacyDtoToPaymentMethods,
  invoicesTransporterDtoToPaymentMethods,
  userWalletConfigDtoToModel
} from './transformers/payments';
import {
  CreateWalletInvoiceRequest,
  WalletInvoiceResponse,
  CreditCardsDto,
  CreditCardsDtoTransformer,
  InvoicesLegacyDto,
  UserWalletConfigDto
} from './models/payments';
import { sagwClient } from './clients';
import { dtoToMerchantConfig } from './transformers/configs';
import {
  CreatePurchaseRequest,
  CreatePurchaseResponse,
  SetDefaultPaymentMethodDto,
  SetPaymentMethodsDto,
  SetSecondaryPaymentMethodDto
} from './dtos/payments';
import { MerchantConfigDTO } from './dtos/configs';
import { PURCHASE_CALLBACK_URL } from '../utils/constants';

export function fetchUserInvoices() {
  return api.get<InvoicesLegacyDto>('/v1/payments/invoices').then(invoicesLegacyDtoToPaymentMethods);
}

export function fetchUserInvoicesTransporter() {
  return sagwClient.get('/mot/user/payment/options/invoice').then(invoicesTransporterDtoToPaymentMethods);
}

export function fetchUserCreditCards() {
  return api.get<CreditCardsDto>('/v1/payments/cards').then(creditCardDtoToPaymentMethod);
}

export function fetchUserCreditCardsTransporter() {
  return sagwClient
    .get<CreditCardsDtoTransformer>('/mot/user/payment/options/card')
    .then(creditCardDtoToPaymentMethodTransformer);
}

export function createUserWalletInvoice(requestBody: CreateWalletInvoiceRequest) {
  return sagwClient.post<WalletInvoiceResponse>('/b2b/wallet/invoice', requestBody);
}

export function fetchUserWalletInvoice(invoiceId: string) {
  return sagwClient.get<WalletInvoiceResponse>(`/b2b/wallet/invoice/${invoiceId}`);
}

export function fetchUserWalletConfig() {
  return sagwClient.get<UserWalletConfigDto>('/mot/user/configs/wallet').then(userWalletConfigDtoToModel);
}

export function setDefaultPaymentMethodUDS(requestBody: SetDefaultPaymentMethodDto) {
  return sagwClient.patch<MerchantConfigDTO>('/mot/merchants/current/payments', requestBody).then(dtoToMerchantConfig);
}

export function setSecondaryPaymentMethodUDS(requestBody: SetSecondaryPaymentMethodDto) {
  return sagwClient.patch<MerchantConfigDTO>('/mot/merchants/current/payments', requestBody).then(dtoToMerchantConfig);
}

export function setPaymentMethodsUDS(requestBody: SetPaymentMethodsDto) {
  return sagwClient.patch<MerchantConfigDTO>('/mot/merchants/current/payments', requestBody).then(dtoToMerchantConfig);
}

export async function createPurchaseWithCard({
  invoiceId,
  cardId,
  cvc
}: CreatePurchaseRequest): Promise<CreatePurchaseResponse> {
  const payload = {
    invoiceId,
    paymentInstrument: {
      useBalance: false,
      card: {
        id: cardId,
        ...(typeof cvc === 'number' ? { cvc } : {}),
        is3DSCheckoutFlowSupported: true,
        callbackUrl: PURCHASE_CALLBACK_URL
      }
    }
  };
  return sagwClient.post<CreatePurchaseResponse>('/mot/user/purchases', payload, {
    headers: { 'X-Idempotency-Key': invoiceId }
  });
}
